"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCreateApolloUploadClient = exports.useCreateApolloClient = void 0;
var react_1 = require("react");
var link_context_1 = require("@apollo/link-context");
var apollo_upload_client_1 = require("apollo-upload-client");
var client_1 = require("@apollo/client");
function useCreateApolloClient(_a) {
    var authorization = _a.authorization, uri = _a.uri;
    return react_1.useMemo(function () {
        var httpLink = client_1.createHttpLink({ uri: uri });
        var authLink = link_context_1.setContext(function (_, _a) {
            var headers = _a.headers;
            return ({
                headers: __assign(__assign({}, headers), { authorization: authorization }),
            });
        });
        return new client_1.ApolloClient({
            link: authLink.concat(httpLink),
            cache: new client_1.InMemoryCache({ addTypename: false }),
        });
    }, [authorization, uri]);
}
exports.useCreateApolloClient = useCreateApolloClient;
function useCreateApolloUploadClient(_a) {
    var authorization = _a.authorization, uri = _a.uri;
    return react_1.useMemo(function () {
        var httpLink = apollo_upload_client_1.createUploadLink({ uri: uri });
        var authLink = link_context_1.setContext(function (_, _a) {
            var headers = _a.headers;
            return ({
                headers: __assign(__assign({}, headers), { authorization: authorization }),
            });
        });
        return new client_1.ApolloClient({
            link: authLink.concat(httpLink),
            cache: new client_1.InMemoryCache({ addTypename: false }),
        });
    }, [authorization, uri]);
}
exports.useCreateApolloUploadClient = useCreateApolloUploadClient;
//# sourceMappingURL=useCreateApolloClient.js.map